/**
 *  このファイルはtools/generate.tsにより生成されたファイルです。手動で編集しないでください。
 */

import { EntityDataApi } from "../../IndexedDBApi";
import { QualityMeasurementItemBase } from "../../../../schema/generated/QualityMeasurementItem";
import { idbEntityDefs } from "../../generated/entityDefs";

// 固有処理を持たない薄いDataApi。共通CRUD/キャッシュはEntityDataApiに集約。
export class QualityMeasurementItemDataApi extends EntityDataApi<QualityMeasurementItemBase> {
  public readonly def = idbEntityDefs.QualityMeasurementItem;
}